import { CustomTableColumn } from "./custom-table-column";

export class StoreOrderBuyerTableColumn extends CustomTableColumn {

    constructor(label: string) {
        super("buyer", label, "buyer");
    }
}
